export default __webpack_public_path__ + "static/media/card-w-review@3x.3a836d3a.png";